import { errorMessageForApolloClientGraphqlError } from '@common/api/graphql/errorMessage';
import type { GraphQLFormattedError } from 'graphql';
import { graphqlFailure } from '../actions';
import type { AppThunkAction } from '../thunkType';

export const handleGraphqlErrors =
  (
    errors: ReadonlyArray<GraphQLFormattedError>
  ): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(graphqlFailure([errorMessageForApolloClientGraphqlError]));
    return Promise.reject(JSON.stringify(errors));
  };
